<template>
  <div>
    <header>
      <p v-on:click="backHistory" style="padding-left: 0; " >
        <img src="@/assets/img/back.png" alt="">
        <!--<span style="color: #FFFFFF">添加项目经历</span>-->
      </p>
      <!--<p style="padding-right: 2rem;color: #FFFFFF ">删除</p>-->
    </header>
    <div class="main">
      <div class="top">
        <div class="wanna_header" >求职期望</div>
        <div class="bianji">
          <span class="wanna_color" style="">每个求职期望都会有专属的职位推荐</span>
        </div>
      </div>
      <div id="qzyx">
        <div class="wanna" v-for="(index,key) in list" @click="toJobdetails(index.id)">
          <div class="wanna_title arrow">
            <span id="wanna_work_name" v-model="list.expectposition">{{index.expectposition}}</span>
          </div>
          <div class="wanna_item" >
            <span id="wanna_city" v-model="list.expectposition">{{index.workcity}}</span>&nbsp;
            &nbsp;&nbsp;
            <!--<span id="wanna_xz" v-model="qwxz">{{qwxz}}</span>-->
            <span id="wanna_xz" v-if="index.expectsalary==1">1K-2K</span>
            <span v-else-if="index.expectsalary==2">2K-4K</span>
            <span v-else-if="index.expectsalary==3">4K-6K</span>
            <span v-else-if="index.expectsalary==4">6K-8K</span>
            <span v-else-if="index.expectsalary==5">8K-10K</span>
            <span v-else-if="index.expectsalary==6">10K-15K</span>
            <span v-else-if="index.expectsalary==7">20K-25K</span>
            <span v-else-if="index.expectsalary==8">20K-25K</span>
            <span v-else-if="index.expectsalary==9">25K-35K</span>
            <span v-else-if="index.expectsalary==10">35K-50KK</span>
            <span v-else-if="index.expectsalary==11">50K-70K</span>
            <span v-else-if="index.expectsalary==12">70K-100K</span>
            <span v-else-if="index.expectsalary==13">100K以上</span>
            <!--<span v-if="scope.row.dStatus&&scope.row.dStatus.deviceStatus==1">正常</span>-->
            <!--<span v-else-if="scope.row.dStatus&&scope.row.dStatus.deviceStatus==2">故障</span>-->
            <!--<span v-else-if="scope.row.dStatus&&scope.row.dStatus.deviceStatus==3">断线</span>-->
          </div>
        </div>

        <!--<div class="wanna">-->
          <!--<div class="wanna_title arrow">-->
            <!--<span>PHP</span>-->
          <!--</div>-->
          <!--<div class="wanna_item">-->
            <!--<span>北京</span>&nbsp;&nbsp;&nbsp;<span>10k-15k</span>-->
          <!--</div>-->
        <!--</div>-->
      </div>

      <div class="jia add" @click="toAddJob(id)">添加求职期望</div>

      <div class="wanna_status_div">
        <div class="wanna_status_title">
          <span>求职状态</span>
        </div>
        <div class="wanna_status_item wanna_status_arrow">
          <van-dropdown-menu active-color="#000000" direction="up" style="height: 20px" >
            <van-dropdown-item v-model="value1" :options="option1" active-color="#000000" @change="saveJobStatuser(value)"  placeholder="请选择"/>
          </van-dropdown-menu>
          <!--<input type="hidden" id="resumeid" value=''>-->
          <!--<input type="hidden" id="jobstatus" value=''>-->
          <!--<span class="job_status">请选择</span>-->
          <!--<div class="select_box select_box2"></div>-->
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'jobWanted',
    data () {
      return {
        msg: '',
        list:{},
        qwxz:'',
        id:'',
        value1:"请选择",
        option1: [
          { text: '请选择', value: 0 },
          { text: '离职随时到岗', value: 1 },
          { text: '在职月内到岗', value: 2 },
          { text: '在职考虑机会', value: 3 },
          { text: '在职暂不考虑', value: 4 }
          ]
      }
    },
    mounted(){
    this.getJobWanteder()
    },
    methods:{
      backHistory(){
        this.$router.go(-1)
      },
      toJobdetails(id){
//        this.$router.push('/jobWanteDetails')
        this.$router.push({
          path:"/jobWanteDetails",
          query:{
            id:id
          }
//          path:`/jobWanteDetails/${id}`
//            `/jobWanted/${id}`
        })
      },
      toAddJob(id){
        this.$router.push({
          path: "/addJobWanted",
          query:{
            id:id
          }
        }
        )
      },
      saveJobStatuser(value){
        this.$api.saveJobStatus({
          "data[jobstatus]":this.value1,
          "id":this.$route.query.id
        })
          .then(res=>{
            if(res.status==200){
              this.$toast("保存成功")
              this.$router.push("/")
            }
          })
      },
      getJobWanteder(){
        this.$api.obtainMy({
          "userid":localStorage.getItem("userid")
        }).then(res=>{
          if(res.status=200){
            this.list=res.data[0].jobintention
            this.id=res.data[0].id
            this.value1=res.data[0].jobstatus?res.data[0].jobstatus:0
            var qwxz=""
            switch (res.data[0]['jobintention'][0]['expectsalary']){
              case 1:
                this.qwxz = '1K-2K';
                break;
              case 2:
                this.qwxz = '2K-4K';
                break;
              case 3:
                this.qwxz = '4K-6K';
                break;
              case 4:
                this.qwxz = '6K-8K';
                break;
              case 5:
                this.qwxz = '8K-10K';
                break;
              case 6:
                this.qwxz = '10K-15K';
                break;
              case 7:
                this.qwxz = '15K-20K';
                break;
              case 8:
                this.qwxz = '20K-25K';
                break;
              case 9:
                this.qwxz = '25K-35K';
                break;
              case 10:
                this.qwxz = '35K-50K';
                break;
              case 11:
                this.qwxz = '50K-70K';
                break;
              case 12:
                this.qwxz = '70K-100K';
                break;
              case 13:
                this.qwxz = '100K以上';
                break;
              default:
                this.qwxz = '';
                break;
            }
          }

//          this.$router.push("/editResume")
        }).catch(err=>{
        })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped="">
  @import '../assets/css/public.css';
  @import '../assets/css/wanna.css';
  header{
    width: 100%;
    height: 56px;
    background-color: #6e9bcf;
    position: fixed;
    top:0 ;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1rem;
    z-index: 100;
  }
  header img{
    width: 20px;
    /*height: 20px;*/
  }
</style>



// WEBPACK FOOTER //
// src/components/jobWanted.vue